import ApiService from '@/services/ApiService'
import TranslationService from '@/services/TranslationService'
import AuthorizationService from '@/services/AuthorizationService'
import store from '@/store/store'
import swal from 'sweetalert'

let api = new ApiService()

export default {
    /**
     * Gets all rental items of the selected warehouse.
     * @param {*} index the page index of the collection
     * @param {*} size the page size of the collection
     * @param {*} search the search therm to be searched on, default null
     * @param {*} categoryID the ID of the category of the items
     */
    async getItems (index, size, search = null, categoryID = null) {
        let params = {}
        // let temp1 = AuthorizationService.isUserLoggedIn()
        // let temp2 = store.getters.warehouse.WarehouseID
        // if (temp1 && temp2) {
        if (AuthorizationService.isUserLoggedIn() && store.getters.warehouse.WarehouseID) {
            params.WarehouseID = store.getters.warehouse.WarehouseID
        }
        if (search) {
            params.Brand = search
            params.Description = search
            params.Notes = search
        } else if (categoryID) {
            params.CategoryIDs = categoryID
        }
        params.size = size
        params.index = index
        let result = await api.get('public/rentalitems', params)
        if (result.ExceptionLevel) {
            swal({icon: result.ExceptionLevel.toLowerCase(), text: TranslationService.get(result.Message)})
            result = {
                Collection: [],
                Index: 1,
                Size: 0
            }
        } else if (!result) {
            result = {
                Collection: [],
                Index: 1,
                Size: 0
            }
        }
        return result
    },

    /**
    * Get the rental item by its ID.
    * @param {*} itemID the id of the rental item.
    * @param {*} warehouseID the id of the warehouse.
    */
    async getItem (itemID) {
        let warehouseID = store.getters.warehouse.WarehouseID
        let result = await api.get('public/rentalitems/' + itemID, {
            warehouseID
        })
        return result
    },

    /**
     * Get the compositions by its ID.
     * @param {*} compositionID the id of the composition.
     */
    async getComposition (compositionID) {
        let result = await api.get('public/compositions/' + compositionID)
        return result
    }

}



// WEBPACK FOOTER //
// ./src/services/ItemService.js